var map = {
	"./de/Abb14-Pflanzen-Bodenwasserspeicher-Transp-Muc-Wzbg.png": 90799,
	"./en/Abb14-Pflanzen-Bodenwasserspeicher-Transp-Muc-Wzbg.png": 9799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87728;